module.exports = __webpack_public_path__ + "img/ECGCABLESNAP.0d4319a9.jpg";